import { useState, useEffect } from 'react';
import { Box, Button, Typography, Card, CardContent, Switch, FormControlLabel } from '@mui/material';
import { Link } from 'react-router-dom';
import { Tv, Fullscreen, VolumeOff, VolumeUp } from '@mui/icons-material';

const TvLauncherPage = () => {
    const [isFullscreen, setIsFullscreen] = useState(false);
    const [isMuted, setIsMuted] = useState(false);
    
    useEffect(() => {
        // Salva la preferenza audio
        localStorage.setItem('tvAlertSound', isMuted ? 'muted' : 'on');
    }, [isMuted]);
    
    useEffect(() => {
        // Recupera la preferenza salvata
        const savedPref = localStorage.getItem('tvAlertSound');
        if (savedPref === 'muted') {
            setIsMuted(true);
        }
    }, []);
    
    const enterFullscreen = () => {
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen()
              .then(() => {
                setIsFullscreen(true);
              })
              .catch(err => {
                console.error(`Errore con il fullscreen: ${err.message}`);
              });
        }
    };
    
    const toggleMute = () => {
        setIsMuted(!isMuted);
    };
    
    return (
        <Box 
            sx={{ 
                display: 'flex', 
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                bgcolor: 'background.default',
                p: 3
            }}
        >
            <Card sx={{ maxWidth: 600, width: '100%', mb: 4, textAlign: 'center' }}>
                <CardContent>
                    <Typography variant="h4" gutterBottom>
                        Display Smart TV - Casa Francescana
                    </Typography>
                    
                    <Box sx={{ my: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                        <Button 
                            component={Link}
                            to={`/tv-display${isMuted ? '?mute=1' : ''}`}
                            variant="contained"
                            color="primary"
                            size="large"
                            startIcon={<Tv />}
                            sx={{ minWidth: 200 }}
                            onClick={enterFullscreen}
                        >
                            Avvia Display TV
                        </Button>
                        
                        <Button 
                           
                            startIcon={<Fullscreen />}
                            onClick={enterFullscreen}
                        >
                            Attiva Schermo Intero
                        </Button>
                        
                        <FormControlLabel
                            control={
                                <Switch 
                                    checked={!isMuted}
                                    onChange={toggleMute}
                                    color="primary"
                                />
                            }
                            label={
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    {isMuted ? <VolumeOff color="disabled" /> : <VolumeUp color="primary" />}
                                    <Typography>
                                        {isMuted ? "Suono allarmi disattivato" : "Suono allarmi attivato"}
                                    </Typography>
                                </Box>
                            }
                        />
                    </Box>
                    
                    <Typography variant="body2" sx={{ fontStyle: 'italic', mt: 2 }}>
                        Questa pagina è riservata alla visualizzazione su Smart TV o su un display dedicato.
                        <br/>Mostra un carosello di immagini che verrà interrotto in caso di allarmi.
                    </Typography>
                </CardContent>
            </Card>
        </Box>
    );
};

export default TvLauncherPage;